// import React from "react";

// export default class NotifyToast extends React.Component {
//     render() {
//         return (
//             <div className="notify-toast">
//                 <div className="notify-toast__dialog">
//                     <div className="notify-toast__content">
//                         <div className="notify-toast__stack">
//                             <p><strong>Incident_datasource</strong> has been added to your likes.</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }
import React from "react";
export default class NotifyToast extends React.Component {
    render() {
        const { message } = this.props;

        return (
            <div className="notify-toast">
                <div className="notify-toast__dialog">
                    <div className="notify-toast__content">
                        <div className="notify-toast__stack">
                            <p>{message}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
